(function () {
    window.js = window.js || {};
    js.hero = (function () {
    	var
			_domElm,
    		_imageWrapper;

        function initialize(domElm) {
    		_domElm = domElm;
        	_imageWrapper = domElm.querySelector('.js-hero__image-wrapper');
			
        	if (_imageWrapper && _imageWrapper.dataset.hasBg) {
        		mq.phablet.addListener(widthChange);
        		widthChange(mq.tablet);
        	}

			// @Wassim: check if the video banners still work. And note that domElm is a reference to the hero banner div so you will be able to use that as a base for selectors.

    		// Remove autoplay on overlay video
        	var oVideo = document.querySelector('.hero__video-overlay iframe');
        	if (!oVideo)
        		return;	// if there is no overlay iframe just exit here - otherwise the next line of code will crash

        	var oVideoSrc = oVideo.src;
        	var oVideoChanged = oVideoSrc + '&autoPlay=0';

        	oVideo.setAttribute('data-src', oVideoChanged);
        	oVideo.setAttribute('src', oVideoChanged);

    		// Stop video when pop is closed 
        	var oInput = document.querySelector('#hero__video-input');
        	if (!oInput)
        		return; // if there is no input button just exit - otherwise the following line will make the script crash.

			

        	oInput.addEventListener('click', function () {
        		if (!oInput.checked) {
        			oVideo.setAttribute('data-src', oVideoChanged);
        			oVideo.setAttribute('src', '');
        			domElm.setAttribute('style', '');
        		}
        		else if (oInput.checked) {
        			oVideo.setAttribute('src', oVideoChanged);
        			domElm.setAttribute('style', 'z-index: 200;');
        		}
        	});


    	}

    	function widthChange(mediaQuery) {
    		var
				heroContentWidth = Math.min(1280, window.innerWidth),
				style,
				fXpct,		// the percentagewise position of the focal point on the image.
				fhX,		// the x position in pixels from the left in pixes where the focal point of hero should be positioned.
				fhXpct,		// the x position in percent from the left in percent where the hero should be positioned
				fhXoffset,  // the percentage-wise offset that the hero image needs to be moved.
				signMultiplier;


    		if (mediaQuery.matches) {
    			style = 'background-image: url(' + _imageWrapper.dataset.bgDesktop + ');';

    			if (_imageWrapper.dataset.isExpert) {
    				fXpct = _imageWrapper.dataset.focalpointX;

    				fhX = heroContentWidth / 5 + (window.innerWidth - heroContentWidth) / 2;

    				fhXpct = (fhX / window.innerWidth) * 100;

    				fhXoffset = fhXpct - fXpct;
    				signMultiplier = fhXoffset / Math.abs(fhXoffset);

    				fhXoffset = (Math.pow(Math.abs(fhXoffset / 100) + 1, 2) - 1) * 100 * signMultiplier;

    				style += 'margin-left: ' + fhXoffset + '%; height: ' + (window.innerWidth * 0.5625) + 'px;';
    				//console.log('fhXpct =', fhXpct);
    				//console.log('fhX =', fhX);
    				//console.log('fhXoffset =', fhXoffset + '%');
    			}
    			_imageWrapper.setAttribute('style', style);
			} else {
    			_imageWrapper.setAttribute('style',  'background-image: url(' + _imageWrapper.dataset.bgMobile + ');');
    		}
    	}


    	// Moved the video code from here as all code here will be executed on all pages - and the code would fail on pages with no hero iframe. I have moved it to the initialize function
		// as it will only be executed on pages with hero banners.

        
        return {
            initialize: initialize
        };
    })();
})();